import React from "react";

import { forceArray } from "/lib/helsecore/forceArray";
import SideMenuItem from "../Elements/SideMenuItem";

import type { SideMenuElement } from "../types.d";

export type SideMenuUIProps = {
  data: SideMenuElement[] | SideMenuElement;
  activeKey?: string; // link
  onItemClick?: (
    item: SideMenuElement,
    e: React.MouseEvent<HTMLAnchorElement>
  ) => void;
  linkProps?: React.AnchorHTMLAttributes<HTMLAnchorElement> & Record<string, unknown>;
  useHierarchicalNumbering: boolean; // add number displayed with the title, for example for chapters and sub-chapters
  openByDefault?: boolean;
  title?: string; // descriptive title for the navigation
};

export default function SideMenu(props: SideMenuUIProps) {
  const {
    data, activeKey, onItemClick, linkProps, useHierarchicalNumbering, title, openByDefault
  } = props;

  return (
    <nav className="w-full border border-solid border-neutral-subtle rounded-sm" aria-label={title || "Sidemeny"}>
      <ol className="divide-y-sm divide-neutral divide-solid flex flex-col list-none m-0 p-0">
        { forceArray(data).map((item: SideMenuElement) => (
          <SideMenuItem
            key={item._id}
            item={item}
            activeKey={activeKey}
            onItemClick={onItemClick}
            linkProps={linkProps}
            useHierarchicalNumbering={useHierarchicalNumbering}
            openByDefault={openByDefault}
          />
        ))}
      </ol>
    </nav>
  );
}
